import React from 'react';

const css = `
    .program-administrator-cls-1 {
        fill: none;
        stroke: #003b63;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
`

const ProgramAdministratorIcon = () => {
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.653 20.653">
            <style>{css}</style>
            <path className="program-administrator-cls-1" d="M14.826,10.33c0,1.45-.69,2.74-1.76,3.56-.75.59-1.7.94-2.74.94-1.03,0-1.98-.35-2.74-.94-1.07-.82-1.76-2.11-1.76-3.56,0-2.49,2.02-4.5,4.5-4.5s4.5,2.01,4.5,4.5Z"/>
            <circle className="program-administrator-cls-1" cx="10.326" cy="9.041" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="10.326" cy="1.826" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="16.337" cy="4.316" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="18.826" cy="10.326" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="16.337" cy="16.337" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="10.326" cy="18.826" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="4.316" cy="16.337" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="1.826" cy="10.326" r="1.326"/>
            <circle className="program-administrator-cls-1" cx="4.316" cy="4.316" r="1.326"/>
            <path className="program-administrator-cls-1" d="M13.066,13.89c-.75.59-1.7.94-2.74.94-1.03,0-1.98-.35-2.74-.94.09-1.43,1.28-2.56,2.74-2.56s2.65,1.13,2.74,2.56Z"/>
            <line className="program-administrator-cls-1" x1="10.326" y1="5.826" x2="10.326" y2="3.153"/>
            <line className="program-administrator-cls-1" x1="13.508" y1="7.144" x2="15.399" y2="5.254"/>
            <line className="program-administrator-cls-1" x1="14.826" y1="10.326" x2="17.5" y2="10.326"/>
            <line className="program-administrator-cls-1" x1="13.508" y1="13.508" x2="15.399" y2="15.399"/>
            <line className="program-administrator-cls-1" x1="10.326" y1="14.826" x2="10.326" y2="17.5"/>
            <line className="program-administrator-cls-1" x1="7.144" y1="13.508" x2="5.254" y2="15.399"/>
            <line className="program-administrator-cls-1" x1="5.826" y1="10.326" x2="3.153" y2="10.326"/>
            <line className="program-administrator-cls-1" x1="7.144" y1="7.144" x2="5.254" y2="5.254"/>
        </svg>
    )
}

export default ProgramAdministratorIcon;